import {
  Box,
  Button,
  Center,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  NumberFormatter,
  Tabs,
  Text,
  ThemeIcon,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow, IconX } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { repositoryPos } from "../../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../../_base/extension/NotificationExtension";
import { orange, peach, sky_blue } from "../../../../../const/variables";
import { MessageResponse } from "../../../../../model/MessageResponse";
import {
  itemAddOnPromotionModel,
  itemGiftPromotionModel,
  TblItemPromotionModel,
} from "../../../../../model/TblItem";
import AddOnTable from "./AddOnTable";
import GiftTable from "./GiftTable";
import "./voucher.css";
import VoucherList from "./VoucherList";

interface VoucherProps {
  branchId: number;
  idItem: string;
  price: number;
  handleSelectProductAddOn: (
    product: itemAddOnPromotionModel[],
    idItem: string
  ) => Promise<void>;
  handleSelectProductGift: (
    product: itemGiftPromotionModel[],
    idItem: string
  ) => Promise<void>;
  handleSelectPromotionMain: any;
  handleRemovePromotion?: (itemId: string) => void;
  isWholesale?: boolean;
  currentIdPromote?: number;
}

const VoucherRefactor = ({
  idItem,
  branchId,
  price,
  handleSelectProductAddOn,
  handleSelectProductGift,
  handleSelectPromotionMain,
  handleRemovePromotion,
  isWholesale,
  currentIdPromote,
}: VoucherProps) => {
  const [visible, { open, close }] = useDisclosure(false);
  const [dataPromotion, setDataPromotion] = useState<TblItemPromotionModel[]>(
    []
  );
  const [selectedPromotion, setSelectedPromotion] =
    useState<TblItemPromotionModel | null>(null);

  const [listSelectedAddOn, setListSelectedAddOn] = useState<
    itemAddOnPromotionModel[]
  >([]);

  const [listSelectedGift, setListSelectedGift] = useState<
    itemGiftPromotionModel[]
  >([]);

  const handleOptionChange = (option: TblItemPromotionModel) => {
    // Nếu là đơn buôn và click vào CTKM đang chọn thì cho phép bỏ chọn (toggle)
    if (
      isWholesale &&
      (selectedPromotion?.tblPromotion?.id === option?.tblPromotion?.id ||
        selectedPromotion === option)
    ) {
      setSelectedPromotion(null);
      setListSelectedAddOn([]);
      setListSelectedGift([]);
    } else {
      setSelectedPromotion(option);
    }
  };

  // const handleChangeItemGiftPromotion = (
  //   promotionItem: itemGiftPromotionModel
  // ) => {
  //   setSelectedItemGiftPromotion((prevData) => {
  //     return prevData.includes(promotionItem)
  //       ? prevData.filter((item) => item !== promotionItem)
  //       : [...prevData, promotionItem];
  //   });
  // };

  const handleSaveVoucher = () => {
    if (isWholesale && !selectedPromotion) {
      handleRemoveVoucher();
      return;
    }

    if (listSelectedAddOn) {
      handleSelectProductAddOn(listSelectedAddOn, idItem);
    }
    if (listSelectedGift) {
      handleSelectProductGift(listSelectedGift, idItem);
    }

    handleSelectPromotionMain(selectedPromotion);

    modals.closeAll();
  };

  // Hàm bỏ chọn CTKM - chỉ dành cho bán buôn
  const handleRemoveVoucher = () => {
    if (handleRemovePromotion) {
      handleRemovePromotion(idItem);
      modals.closeAll();
      NotificationExtension.Success("Đã bỏ chọn CTKM thành công!");
    }
  };

  useEffect(() => {
    const handleFetchDataVoucher = async () => {
      open();
      const response = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblItem/item-promotion",
        {
          id: idItem,
          price: price,
          branch: branchId,
        }
      );

      if (response && response.success) {
        let result = response.data;
        setDataPromotion(result || []);
        if (result?.length > 0) {
          if (
            isWholesale &&
            (currentIdPromote === 0 ||
              currentIdPromote === null ||
              currentIdPromote === undefined)
          ) {
            // Đã bỏ chọn CTKM trước đó trên đơn buôn -> không tự động chọn
            setSelectedPromotion(null);
          } else if (currentIdPromote) {
            // Tìm CTKM tương ứng với currentIdPromote
            const found = result.find(
              (item: any) =>
                item?.tblPromotionItemPrimary?.some(
                  (p: any) => p.id === currentIdPromote
                ) || item?.tblPromotion?.id === currentIdPromote
            );
            setSelectedPromotion(found || result[0]);
          } else {
            setSelectedPromotion(result[0]);
          }
        }
      } else {
        NotificationExtension.Fails("Lấy thông tin khuyến mại thất bại !");
      }
      close();
    };

    if (idItem) {
      handleFetchDataVoucher();
    }
  }, [idItem, price, close, open, branchId, isWholesale, currentIdPromote]);

  return (
    <Box mih={550}>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid>
        <Grid.Col span={{ base: 5, md: 4, xs: 4 }}>
          <VoucherList
            dataVoucher={dataPromotion}
            selectedPromotion={selectedPromotion}
            handleOptionChange={handleOptionChange}
            peach={peach}
            orange={orange}
            isWholesale={isWholesale}
          />
        </Grid.Col>

        <Grid.Col span={{ base: 7, md: 8, xs: 8 }}>
          {selectedPromotion ? (
            <Tabs defaultValue="gift">
              <Tabs.List>
                <Tabs.Tab value="gift">Mặt hàng quà tặng</Tabs.Tab>
                <Tabs.Tab value="addOn">Mặt hàng mua kèm</Tabs.Tab>
              </Tabs.List>

              <Tabs.Panel value="gift">
                <GiftTable
                  selectedPromotion={selectedPromotion}
                  listSelectedGift={listSelectedGift}
                  setListSelectedGift={setListSelectedGift}
                />
              </Tabs.Panel>

              <Tabs.Panel value="addOn">
                <AddOnTable
                  setListSelectedAddOn={setListSelectedAddOn}
                  listSelectedAddOn={listSelectedAddOn}
                  selectedPromotion={selectedPromotion}
                />
              </Tabs.Panel>
            </Tabs>
          ) : (
            <Box
              p="xl"
              style={{
                height: 480,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "1px dashed #ced4da",
                borderRadius: "10px",
                backgroundColor: "#fcfcfc",
              }}
            >
              <ThemeIcon size={60} radius="xl" color="gray" variant="light" mb="md">
                <IconX size={34} />
              </ThemeIcon>
              <Text fw={700} size="lg" c="dimmed">
                Đã bỏ chọn chương trình khuyến mãi
              </Text>
              <Text size="sm" c="dimmed" ta="center" mt="xs" maw={400}>
                Sản phẩm sẽ được bán theo giá bán buôn gốc và không kèm theo quà tặng / mua kèm.
              </Text>
              {dataPromotion?.length > 0 && (
                <Button
                  variant="light"
                  color="teal"
                  size="xs"
                  mt="md"
                  leftSection={<IconCheck size={16} />}
                  onClick={() => setSelectedPromotion(dataPromotion[0])}
                >
                  Chọn lại CTKM
                </Button>
              )}
            </Box>
          )}
        </Grid.Col>
      </Grid>

      <Flex align={"center"} justify={"space-between"}>
        <Group mt="xs">
          <Text fw={700} mb="5" size="md">
            Tổng tiền được giảm:{" "}
            <Text span c={"red"} fw={700}>
              <NumberFormatter
                value={
                  selectedPromotion?.tblPromotionItemPrimary[0]
                    ? price -
                        (selectedPromotion?.tblPromotionItemPrimary[0]
                          ?.priceDiscount || 0) || 0
                    : 0
                }
                thousandSeparator="."
                decimalSeparator=","
                suffix="₫"
              />
            </Text>
          </Text>
        </Group>
        <Group
          justify="end"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          {isWholesale && handleRemovePromotion && (
            <Button
              type="button"
              color={selectedPromotion ? "red" : "gray"}
              variant="outline"
              onClick={() => {
                if (selectedPromotion) {
                  // Đang chọn -> bấm để chuyển ngay sang trạng thái bỏ chọn
                  setSelectedPromotion(null);
                  setListSelectedAddOn([]);
                  setListSelectedGift([]);
                } else {
                  // Đã bỏ chọn -> xác nhận gỡ và đóng modal
                  handleRemoveVoucher();
                }
              }}
              leftSection={<IconX size={18} />}
            >
              {selectedPromotion ? "Bỏ chọn CTKM" : "Xác nhận đã bỏ chọn"}
            </Button>
          )}
          <Button
            type="button"
            color="gray"
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={<IconWindow size={18} />}
          >
            Đóng
          </Button>
          <Button
            color={sky_blue.base}
            leftSection={<IconCheck size={18} />}
            onClick={() => handleSaveVoucher()}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Flex>
    </Box>
  );
};

export default VoucherRefactor;
